import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { SapAccountCompanyCode } from '../sap-account-company-code/sap-account-company-code';
import { SapRelationSapAccountOldAccount } from '../sap-relation-sap-account-old-account/sap-relation-sap-account-old-account';
FieldBuilder.setNamespace('Controlling');

export const ACCOUNT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Account.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.Account.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
];

export const ACCOUNT_CONFIG = {
  entityName: 'Account',
  localizationKey: 'Controlling::Entity.Account',
  fields: ACCOUNT_FIELDS,
  permission: 'ControllingSap.Accounts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'SapAccountCompanyCode',
      foreignKeyField: 'accountId',
      localizationKey: 'Controlling::Entity.SapAccountCompanyCode',
      component: SapAccountCompanyCode,
    },
    {
      entityName: 'SapRelationSapAccountOldAccount',
      foreignKeyField: 'accountId',
      localizationKey: 'Controlling::Entity.SapRelationSapAccountOldAccount',
      component: SapRelationSapAccountOldAccount,
    },
  ],
};
